import { Box, Typography, styled } from '@mui/material';

import {
  CALENDAR_COLUMNS_TEMPLATE,
  CALENDAR_HEADER_HEIGHT,
} from '../../components/CalendarDayHeader/CalendarDayHeader.styles';
import {
  CALENDAR_GRID_WIDTH_COMPENSATION,
  CALENDAR_PANEL_BASE_STYLES,
  CALENDAR_SCROLL_CONTENT_SPACING,
} from '../../shared/Calendar.layout';

export const WeekViewWrapper = styled(Box)(() => ({
  ...CALENDAR_PANEL_BASE_STYLES,
  display: 'grid',
  gridTemplateRows: `${CALENDAR_HEADER_HEIGHT} minmax(0, 1fr)`,
  height: '100%',
  overflow: 'hidden',
}));

export const WeekBodyScrollArea = styled(Box)(() => ({
  position: 'relative',
  minHeight: 0,
  overflow: 'hidden',
}));

export const WeekBodyScroller = styled(Box)(() => ({
  position: 'absolute',
  inset: 0,
  ...CALENDAR_SCROLL_CONTENT_SPACING,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const WeekColumnsFrame = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: CALENDAR_COLUMNS_TEMPLATE,
  gridTemplateRows: 'minmax(0, 1fr)',
  alignItems: 'stretch',
  flex: '1 1 0',
  minHeight: '100%',
  alignSelf: 'stretch',
  width: CALENDAR_GRID_WIDTH_COMPENSATION,
}));

export const WeekBodyCell = styled(Box)(() => ({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  alignSelf: 'stretch',
  minHeight: 0,
  minWidth: 0,
  padding: '16px 10px 10px',
  alignItems: 'flex-start',
  background: '#FFF',
  position: 'relative',
  borderRight: '1px solid var(--Gray-200, #DBDBE2)',
  '&:nth-of-type(7n)': {
    borderRight: 'none',
  },
}));

export const DayNumberWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: '10px',
  left: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const DayNumberText = styled(Typography)(() => ({
  color: '#504E5A',
  fontFamily: '"Neue Frutiger World"',
  fontSize: '20px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '120%',
}));

export const EventContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '10px',
  alignSelf: 'stretch',
  marginTop: '32px',
  width: '100%',
}));
